/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MessageLevelEnum = 'INFO' | 'ERROR' | 'WARN';

export const MessageLevelEnum = {

    INFO: 'INFO' as MessageLevelEnum,

    ERROR: 'ERROR' as MessageLevelEnum,

    WARN: 'WARN' as MessageLevelEnum
};

